import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const Row = props => {
  const RowSizes = ['small', 'medium', 'large']

  const rowClasses = ['row']

  if (props.collapse) {
    if (props.collapse === true) {
      rowClasses.push('collapse')
    } else {
      RowSizes.forEach(size => {
        if (props.collapse[size]) {
          rowClasses.push(size + '-collapse')
        }
      })
    }
  }

  if (props.uncollapse) {
    RowSizes.forEach(size => {
      if (props.uncollapse[size]) {
        rowClasses.push(size + '-uncollapse')
      }
    })
  }

  // Keeping this at the end here for backwards compatibility. People have been writing styles based
  // on the assumption that their class is always the last one applied to the element.
  if (props.className) {
    rowClasses.push(props.className)
  }

  return (
    <div
      className={cx(rowClasses)}
      onClick={props.onClick}
      data-elm-id={props.elmId}
    >
      {props.children}
    </div>
  )
}

Row.propTypes = {
  collapse: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({
      small: PropTypes.bool,
      medium: PropTypes.bool,
      large: PropTypes.bool,
    }),
  ]),
  uncollapse: PropTypes.shape({
    small: PropTypes.bool,
    medium: PropTypes.bool,
    large: PropTypes.bool,
  }),
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func,
  elmId: PropTypes.string,
}

const Column = props => {
  const ColumnSizes = ['small', 'medium', 'large', 'print']

  const columnClasses = ['column', props.className]

  ColumnSizes.forEach(size => {
    if (props[size]) {
      columnClasses.push(size + '-' + props[size])
    }
    if (props.offset && typeof props.offset[size] !== 'undefined') {
      columnClasses.push(size + '-offset-' + props.offset[size])
    }
    if (props.push && typeof props.push[size] !== 'undefined') {
      columnClasses.push(size + '-push-' + props.push[size])
    }
    if (props.pull && typeof props.pull[size] !== 'undefined') {
      columnClasses.push(size + '-pull-' + props.pull[size])
    }
    if (props.end) {
      columnClasses.push('end')
    }
  })

  return (
    <div
      className={cx(columnClasses)}
      onClick={props.onClick}
      data-elm-id={props.elmId}
    >
      {props.children}
    </div>
  )
}

/* eslint-disable react/no-unused-prop-types */
Column.propTypes = {
  className: PropTypes.string,
  small: PropTypes.number,
  medium: PropTypes.number,
  large: PropTypes.number,
  offset: PropTypes.shape({
    small: PropTypes.number,
    medium: PropTypes.number,
    large: PropTypes.number,
    print: PropTypes.number,
  }),
  push: PropTypes.shape({
    small: PropTypes.number,
    medium: PropTypes.number,
    large: PropTypes.number,
    print: PropTypes.number,
  }),
  pull: PropTypes.shape({
    small: PropTypes.number,
    medium: PropTypes.number,
    large: PropTypes.number,
    print: PropTypes.number,
  }),
  end: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.node,
  elmId: PropTypes.string,
}
/* eslint-enable react/no-unused-prop-types */

const CenteredRow = ({ children, elmId }) => (
  <Row>
    <Column elmId={elmId} medium={12} className={cx('centered-row')}>
      {children}
    </Column>
  </Row>
)

CenteredRow.propTypes = {
  children: PropTypes.node,
  elmId: PropTypes.string,
}

const GridDeprecated = { Row, Column, CenteredRow }

export default GridDeprecated
